import { USER_REQUEST, USER_REQUEST_PROMISE, USER_ERROR, USER_SUCCESS } from "../actions/user";
import apiCall from "@/utils/api";
import User from '@/models/user';
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  status: "",
  profile: Object.assign(new User, {}),
  filterPresets: JSON.parse(localStorage.getItem('filtersPreset') ?? '[]')
}

const getters = {
  myProfile: state => state.profile,
  myProfileState: state => !!state.profile.id,
  myProfileColor: state => state.profile?.role?.color ?? "transparent",
  filterPresets: state => state.filterPresets
};

const actions = {
  [USER_REQUEST]: ({ commit, rootState }) => {
    commit(USER_REQUEST);
    let uid = rootState.auth.uid;
    apiCall({ url: "users/" + uid })
      .then(resp => {
        commit(USER_SUCCESS, Object.assign(new User, resp));
      })
      .catch(() => {
        commit(USER_ERROR);
      });
  },
  [USER_REQUEST_PROMISE]: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST);
      let uid = rootState.auth.uid;
      apiCall({ url: "users/" + uid })
        .then(resp => {
          commit(USER_SUCCESS, Object.assign(new User, resp));
          resolve(resp);
        })
        .catch(() => {
          commit(USER_ERROR);
          reject();
        });
    });
  },

  // FILTER PRESETS
  ['SAVE_FILTER_PRESET']: ({ state }, preset) => {
    state.filterPresets.push(preset)
    localStorage.setItem('filtersPreset', JSON.stringify(state.filterPresets))
  },
  ['REMOVE_FILTER_PRESET']: ({ state }, index) => {
    state.filterPresets.splice(index, 1)
    localStorage.setItem('filtersPreset', JSON.stringify(state.filterPresets))
  }
};

const mutations = {
  [USER_REQUEST]: state => {
    state.status = "loading";
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = "success";
    Vue.set(state, "profile", resp);
  },
  [USER_ERROR]: state => {
    state.status = "error";
  },
  [AUTH_LOGOUT]: state => {
    state.profile = Object.assign(new User, {});
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
